import { LazyPageLoading } from '@components/lazy-page-loading'
import { lazy, Suspense } from 'react'

const AskAi = lazy(() =>
  import('@pages/ask-ai/ask-ai').then((module) => ({
    default: module.AskAi,
  })),
)

export const AskAiRoute = () => (
  <Suspense fallback={<LazyPageLoading />}>
    <AskAi />
  </Suspense>
)
